import { Box, Button, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography, Modal, CircularProgress } from "@mui/material";
import TokenError from "../tokenError";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import dayjs from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Label } from "flowbite-react";
import pdfImage from '../../assets/images/pdfImage.svg';
import greenTick from '../../assets/icons/greenTic.svg';
import VisibilityIcon from '@mui/icons-material/Visibility';

const Assigned = () => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [open, setOpen] = useState(false);

    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [tokenExpired, setTokenExpired] = useState(false);
    // const [editable, setEditable] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [rows, setRows] = useState([]);
    const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
    const [endDate, setEndDate] = useState(dayjs());
    const [bookingId, setBookingId] = useState('');
    const [cancelledData, setCancelledData] = useState([]);
    const [buttonTab, setButtonTab] = useState(1);
    const [truckHeadId, setTruckHeadId] = useState('');
    const [driverId, setDriverId] = useState('');
    const [helperId, setHelperId] = useState('');
    const [chassisId, setChassisId] = useState('');
    const [vendorId, setVendorId] = useState('');
    const [tmsClientId, setTmsClientId] = useState('');
    const [truckHeadData, setTruckHeadData] = useState([]);
    const [driverData, setDriverData] = useState([]);
    const [helperData, setHelperData] = useState([]);
    const [chassisData, setChassisData] = useState([]);
    const [vendorData, setVendorData] = useState([]);
    const [clientData, setClientData] = useState([]);
    const [foulReason, setFoulReason] = useState('');
    const [isReasonError, setIsReasonError] = useState(false);
    const [cancelReason, setCancelReason] = useState('');
    const [isCancelReasonError, setIsCancelReasonError] = useState(false);
    const [viewRow, setViewRow] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('booking_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [engagementId, setEngagementId] = useState('');
    const [engagementData, setEngagementData] = useState([]);
    const [pdfOpen, setPdfOpen] = useState(false);
    const [isCreatingTicket, setIsCreatingTicket] = useState(false);
    const [isCreatingDr, setCreatingDr] = useState(false);
    const [deliveryReceiptPdfOpen, setDeliveryReceiptPdfOpen] = useState(false);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const fetchClientData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_clients';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setClientData(response.data);
                // const formattedData = formatDataForCSV(response.data);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    const fetchChassisData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_chassis_details';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setChassisData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    const fetchHelpersData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_helpers';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setHelperData(response.data);
                // const formattedData = formatDataForCSV(response.data);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    const fetchTruckHeadData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_truck_heads';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setTruckHeadData(response.data);
                // const formattedData = formatDataForCSV(response.data);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }
    const fetchDriversData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/driver/fetch_all';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setDriverData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchDispatchData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_bookings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp,
                start_date: startDate.format('YYYY-MM-DD'),
                end_date: endDate.format('YYYY-MM-DD'),
                status: 2 //assigned
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
                // const formattedData = formatDataForCSV(response.data);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchDispatchData();
    },[cityFilter, startDate, endDate])

    const handleViewDetails = (row) =>{
        setEngagementId(row.engagement_id);
        setBookingId(row.booking_id);
        setOpen(true);
        setButtonTab(1);
        setViewRow(row);
        fetchEngagementDetails(row.booking_id);
    }
    useEffect(()=>{
        // fetchCancelledDetails();
        if(buttonTab==2){
            fetchClientData();
            fetchDriversData();
            fetchChassisData();
            fetchHelpersData();
            fetchTruckHeadData();
            setTruckHeadId('');
            setDriverId('');
            setHelperId('');
            setChassisId('');
            // setTmsClientId('');
        }
        if(buttonTab==5 || buttonTab==6){
            setFoulReason('');
            setIsReasonError(false);
        }
    }, [bookingId, open, buttonTab])
    // useEffect(() => {
    //     if(bookingId!='')
    //     setOpen(true);
    // }, [cancelledData, bookingId])

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const fetchEngagementDetails = async(bookingId) => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_booking_engagements';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                // city_id: cityFilter,
                timestamp: timestamp,
                booking_id: bookingId
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                console.log('response', response.data[0]);
                setEngagementData(response.data[0]);
                // const formattedData = formatDataForCSV(response.data);
                // setAllData(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleButtonTabChange = (tab) => {
        setButtonTab(tab);
        
        // Run handleCreateTripTicket when Create Ticket tab is clicked
        if (tab === 4 && (engagementData?.trip_ticket_url=="" || engagementData?.trip_ticket_url==null)) {
            handleCreateTripTicket();
        }
        if (tab === 3 && (engagementData?.deliver_receipt_url=="" || engagementData?.deliver_receipt_url==null)) {
            handleCreateDeliverReceipt();
        }
    }

    const handleSubmit = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            // city_id: cityFilter,
            engagement_status: 1,
            booking_id: bookingId,
            driver_id: driverId,
            helper_id: helperId,
            truck_head_id: truckHeadId,
            chassis_id: chassisId,
            // tms_client_id: tmsClientId,
            engagement_id: engagementId
            // truck_vendor_id: vendorId
        };

        try {
            const url = operationsUrl + '/transport/add_update_engagements';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

        handleClose();
        fetchDispatchData();
    }

    const handleCancel = async(status) => {
        if (cancelReason.trim() === '') {
            setIsCancelReasonError(true);
            return;
        }

        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            booking_id: bookingId,
            booking_status: status,
            reason: cancelReason
        };

        try {
            const url = operationsUrl + '/transport/add_update_engagements';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

        handleClose();
        fetchDispatchData();
    }

    const handleMarkFoul = async(status) =>{
        if (foulReason.trim() === '') {
            setIsReasonError(true);
            return;
        }

        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            booking_id: bookingId,
            booking_status: status,
            reason: foulReason
            // truck_vendor_id: vendorId
        };

        try {
            const url = operationsUrl + '/transport/add_update_bookings';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }

        handleClose();
        fetchDispatchData();
    }

    const handleCreateTripTicket = async() =>{
        setIsCreatingTicket(true);
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            booking_id: bookingId
        };

        try {
            const url = operationsUrl + '/transport/create_trip_ticket';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchEngagementDetails(bookingId);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        }
        catch(error){
            console.log(error);
            setMessage("Failed to Create Trip Ticket");
            showSnackbar(true);
        }
        finally {
            setIsCreatingTicket(false);
        }
    }

    const handleCreateDeliverReceipt = async() =>{
        setCreatingDr(true);
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            booking_id: bookingId
        };

        try {
            const url = operationsUrl + '/transport/create_delivery_receipt';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchEngagementDetails(bookingId);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        }
        catch(error){
            console.log(error);
            setMessage("Failed to Create Deliver Receipt");
            showSnackbar(true);
        }
        finally {
            setCreatingDr(false);
        }
    }

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
            Assigned
            </Typography>

            <Grid2 container spacing={2} alignItems="flex-end" style={{marginBottom: '2%'}}>
                <Grid2 item>
                    <Label></Label><br/>
                    <Select 
                        value={cityFilter} 
                        onChange={(e) => handleCityChange(e.target.value)} 
                        displayEmpty
                        sx={{
                            width: '190px',
                            height: '50px',
                            borderRadius: '8px', marginTop:"8px",
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item sx={{marginLeft:'3%'}}>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDate && startDate && startDate > endDate
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={startDate}
                            onChange={(newValue) => {
                                if (endDate && newValue > endDate) {
                                    // If new start date is after end date, clear end date
                                    setEndDate(null);
                                }
                                setStartDate(newValue);
                            }}
                            maxDate={endDate || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDate && startDate && startDate > endDate
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '50px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px'
                                }
                            }}
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            minDate={startDate || undefined}
                        />
                    </LocalizationProvider>
                </Grid2>
            </Grid2>

            {open && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Paper elevation={3}
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>

                                    <Grid2 container spacing={0.2} alignItems="center">
                                        <Grid2 item>
                                            <Button onClick={()=>handleButtonTabChange(1)} variant="contained" sx={{textTransform:'none', backgroundColor: buttonTab==1?'#0065FF':'#f9f9f9', color: buttonTab==1?'#FFFFFF':'#83888E', boxShadow:'none'}}>View</Button>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button onClick={()=>handleButtonTabChange(2)} variant="contained" sx={{textTransform:'none', backgroundColor: buttonTab==2?'#0065FF':'#f9f9f9', color: buttonTab==2?'#FFFFFF':'#83888E', boxShadow:'none'}}>Reassign</Button>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button onClick={()=>handleButtonTabChange(3)} 
                                                variant="contained" 
                                                disabled={isCreatingDr}
                                                sx={{textTransform:'none', backgroundColor: buttonTab==3?'#0065FF':'#f9f9f9', color: buttonTab==3?'#FFFFFF':'#83888E', boxShadow:'none'}}>
                                                    {isCreatingDr ? 'Creating...' : 'Create DR'}
                                                </Button>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button 
                                                onClick={()=>handleButtonTabChange(4)} 
                                                variant="contained" 
                                                disabled={isCreatingTicket}
                                                sx={{textTransform:'none', backgroundColor: buttonTab==4?'#0065FF':'#f9f9f9', color: buttonTab==4?'#FFFFFF':'#83888E', boxShadow:'none'}}
                                            >
                                                {isCreatingTicket ? 'Creating...' : 'Create Ticket'}
                                            </Button>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button onClick={()=>handleButtonTabChange(5)} variant="contained" sx={{textTransform:'none', backgroundColor: buttonTab==5?'#0065FF':'#f9f9f9', color: buttonTab==5?'#FFFFFF':'#83888E', boxShadow:'none'}}>Cancel</Button>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button onClick={()=>handleButtonTabChange(6)} variant="contained" sx={{textTransform:'none', backgroundColor: buttonTab==6?'#0065FF':'#f9f9f9', color: buttonTab==6?'#FFFFFF':'#83888E', boxShadow:'none'}}>Mark Foul</Button>
                                        </Grid2>
                                    </Grid2>

                                    {buttonTab==1 && (
                                        <>
                                            <Grid2 sx={{marginTop:'6%'}}>
                                                <Typography sx={{color:'#4E545D', fontWeight:'500', fontSize:'24px'}}>
                                                    View Booking
                                                </Typography>
                                            </Grid2>

                                            <Grid container spacing={2} style={{marginBottom:'6%'}}>
                                                                                
                                                <Grid item xs={12} sm={12} sx={{marginTop:'2%'}}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Booking ID</Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Booking ID" fullWidth variant="outlined" type="text"
                                                        value={viewRow.booking_id} disabled
                                                        // onChange={(e) => setTruckerName(e.target.value)}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF'
                                                            },
                                                        }}
                                                    />
                                                </Grid>
            
                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Client</Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Client" fullWidth variant="outlined" type="text"
                                                        value={viewRow.tms_client_id} disabled
                                                        // onChange={(e) => setTruckerName(e.target.value)}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Type of Movement</Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="type of Movement" fullWidth variant="outlined" type="text"
                                                        value={viewRow.container_movement_type} disabled
                                                        // onChange={(e) => setTruckerName(e.target.value)}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
            
                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Container Type<span style={{ color: 'red' }}>*</span></Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Container Type" fullWidth variant="outlined" type="text"
                                                        value={viewRow?.container_type} disabled
                                                        // onChange={handleEmailChange}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
            
                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Container Size<span style={{ color: 'red' }}>*</span></Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Container Size" fullWidth variant="outlined" type="text"
                                                        value={viewRow?.container_size} disabled
                                                        // onChange={handleEmailChange}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                            
                                            <Typography style={{ marginBottom: '18px', marginTop: '8px', fontWeight: '500', fontSize:'20px' }}>
                                                Pre-pickup Container Details
                                            </Typography>
            
                                            <Grid2 sx={{backgroundColor:'#F9F9F9', borderRadius:'8px', padding:'4px', marginBottom:'12px', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                                                <Typography>Pre-pickup Container</Typography>
                                                <Switch
                                                    checked={viewRow.is_pre_pickup_container} disabled
                                                    color="primary"
                                                />
                                            </Grid2>

                                            <Grid container spacing={2} style={{marginBottom:'6%'}}>
                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Pre-pickup Container Source<span style={{ color: 'red' }}>*</span></Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Pre-pickup Container Source" fullWidth variant="outlined" type="text"
                                                        value={viewRow?.pre_pickup_container_pickup_address} disabled
                                                        // onChange={handleEmailChange}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Pre-pickup Container Destination<span style={{ color: 'red' }}>*</span></Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Pre-pickup Container Destination" fullWidth variant="outlined" type="text"
                                                        value={viewRow?.pre_pickup_container_drop_address} disabled
                                                        // onChange={handleEmailChange}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Pre-pickup Container Date & Time<span style={{ color: 'red' }}>*</span></Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Pre-pickup Container Date & Time" fullWidth variant="outlined" type="text"
                                                        value={viewRow?.pre_pickup_container_pickup_time ? dayjs(viewRow.pre_pickup_container_pickup_time).format('DD-MM-YY HH:mm:ss') : ''} disabled
                                                        // onChange={handleEmailChange}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                
                                        
                                            <Typography style={{ marginBottom: '18px', marginTop: '8px', fontWeight: '500', fontSize:'20px' }}>
                                                Schedule Details
                                            </Typography>
            
                                            <Grid container spacing={2} style={{marginBottom:'6%'}}>
                                                                            
                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Pickup Location</Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Pickup Location" fullWidth variant="outlined" type="text"
                                                        value={viewRow.pickup_address} disabled
                                                        // onChange={(e) => setTruckerName(e.target.value)}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF'
                                                            },
                                                        }}
                                                    />
                                                </Grid>
        
                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Drop-off Location</Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Drop-off Location" fullWidth variant="outlined" type="text"
                                                        value={viewRow.drop_address} disabled
                                                        // onChange={(e) => setTruckerName(e.target.value)}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Pickup Date & Time</Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Pickup Date & Time" fullWidth variant="outlined" type="text"
                                                        value={viewRow.pickup_time ? dayjs(viewRow.pickup_time).format('DD-MM-YY HH:mm:ss') : ''} disabled
                                                        // onChange={(e) => setTruckerName(e.target.value)}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
        
                                                <Grid item xs={12} sm={6}>
                                                    <Label style={{color:'#1A1E25', fontSize:'16px'}}>Drop Date & Time<span style={{ color: 'red' }}>*</span></Label>
                                                    <TextField sx={{marginTop:'1%'}} placeholder="Drop Date & Time" fullWidth variant="outlined" type="text"
                                                        value={viewRow?.drop_time ? dayjs(viewRow.drop_time).format('DD-MM-YY HH:mm:ss') : ''}
                                                        disabled
                                                        // onChange={handleEmailChange}
                                                        InputProps={{
                                                            inputProps: { min: 0 }, // Prevent values less than zero
                                                            style: {
                                                                height: '52px',
                                                                borderRadius:'12px',
                                                                fontSize: '16px',
                                                                padding: '8px 14px',
                                                                backgroundColor: '#FFFFFF',
                                                            },
                                                        }}
                                                    />
                                                </Grid>
    
                                            </Grid>
                                        </>
                                    )}

                                    {buttonTab==2 && (
                                        <Grid2 container spacing={2} alignItems="center" style={{marginBottom: '2%' }}>
                                            <Typography variant="h6" style={{ marginBottom: '20px', marginTop: '20px', fontWeight: 'bold' }}>
                                                Reassign Booking
                                            </Typography>
                                        </Grid2>
                                    )}
                                
                                    {buttonTab==2 && (
                                        <> 

                                        <Grid container spacing={2}>
                                            
                                            <Grid item xs={12} sm={6}>
                                                <Label style={{color:'#1A1E25', fontSize:'16px'}}>Truck Head<span style={{ color: 'red' }}>*</span></Label>
                                                <Select sx={{marginTop:'2%'}}
                                                    value={truckHeadId} 
                                                    fullWidth
                                                    onChange={(e) => setTruckHeadId(e.target.value)}
                                                    style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                    {truckHeadData && truckHeadData.map((truckHead) => (
                                                        <MenuItem key={truckHead.truck_head_id} value={truckHead.truck_head_id}>
                                                            {truckHead.truck_plate_no}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Label style={{color:'#1A1E25', fontSize:'16px'}}>Driver<span style={{ color: 'red' }}>*</span></Label>
                                                <Select sx={{marginTop:'2%'}}
                                                    value={driverId} 
                                                    fullWidth
                                                    onChange={(e) => setDriverId(e.target.value)}
                                                    style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                    { driverData&& driverData.map((driver) => (
                                                        <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                                            {driver.driver_name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Label style={{color:'#1A1E25', fontSize:'16px'}}>Helper<span style={{ color: 'red' }}>*</span></Label>
                                                <Select sx={{marginTop:'2%'}}
                                                    value={helperId} 
                                                    fullWidth
                                                    onChange={(e) => setHelperId(e.target.value)}
                                                    style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                    { helperData&& helperData.map((helper) => (
                                                        <MenuItem key={helper.helper_id} value={helper.helper_id}>
                                                            {helper.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Label style={{color:'#1A1E25', fontSize:'16px'}}>Chassis Number<span style={{ color: 'red' }}>*</span></Label>
                                                <Select sx={{marginTop:'2%'}}
                                                    value={chassisId} 
                                                    fullWidth
                                                    onChange={(e) => setChassisId(e.target.value)}
                                                    style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                    { chassisData&& chassisData.map((chassis) => (
                                                        <MenuItem key={chassis.chassis_id} value={chassis.chassis_id}>
                                                            {chassis.chassis_no}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid>

                                            {/* <Grid item xs={12} sm={12}>
                                                <Label style={{color:'#1A1E25', fontSize:'16px'}}>Chassis Number<span style={{ color: 'red' }}>*</span></Label>
                                                <Select sx={{marginTop:'2%'}}
                                                    value={tmsClientId} 
                                                    fullWidth
                                                    onChange={(e) => setTmsClientId(e.target.value)}
                                                    style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                                    { clientData && clientData.map((client) => (
                                                        <MenuItem key={client.tms_client_id} value={client.tms_client_id}>
                                                            {client.tms_client_name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </Grid> */}
                                        </Grid>

                                        <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={handleSubmit}
                                                sx={{width: '140px',height: '50px',textTransform: 'none',
                                                    fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                                Reassign
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleClose}
                                                sx={{
                                                    width: '140px',
                                                    height: '50px',
                                                    textTransform: 'none',
                                                    fontSize: '16px',
                                                    backgroundColor: '#F0F0F0',
                                                    color: '#B0B0B0',
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                        </> 
                                           
                                    )}

                                    {buttonTab==3 && (
                                        <>
                                            <Grid2 sx={{marginTop:'4%'}}>
                                                <Typography sx={{color:'#4E545D', fontWeight:'500', fontSize:'20px'}}>
                                                    {/* Ticket */}
                                                </Typography>
                                            </Grid2>

                                            <Grid2 sx={{marginTop:'2%'}}>
                                                {isCreatingDr ? (
                                                    <Box sx={{width: '100%', height: '126px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                        <CircularProgress size={30} color="primary" />
                                                    </Box>
                                                ) : (
                                                    <>
                                                        {(engagementData?.deliver_receipt_url != "" && engagementData?.deliver_receipt_url != null) && (
                                                            // <Button
                                                            //     variant="contained"
                                                            //     color="primary"
                                                            //     onClick={() => setPdfOpen(true)}
                                                            //     sx={{width: '140px',height: '46px',textTransform: 'none', backgroundColor:'#fff', boxShadow:'none',
                                                            //         fontSize: '16px',border: '1px solid #0065FF',color: '#0065FF', borderRadius:'8px'}}>
                                                            //     View
                                                            // </Button>
                                                            <Grid2 container spacing={4} sx={{marginTop:'8px', alignItems:'center'}}>
                                                                <Grid2 item>
                                                                    <img width="120px" height="120px" src={pdfImage} alt="pdf" />
                                                                    <Typography sx={{color:'#83888E', fontSize:'16px'}}>DeliveryReceipt.pdf</Typography>
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                                                        <img height="20px" width="20px" src={greenTick} alt="greenTick" />
                                                                        <Typography sx={{color:'#34C759', fontSize:'16px', marginLeft:'8px'}}>Delivery Receipt Created Successfully</Typography>
                                                                    </Grid2>
                                                                    <Grid2 item sx={{marginTop:'6%'}}>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"
                                                                            onClick={() => setDeliveryReceiptPdfOpen(true)}
                                                                            sx={{width: '140px',height: '46px',textTransform: 'none', backgroundColor:'#EDF4FF', boxShadow:'none',
                                                                                fontSize: '16px',border: '1px solid #0065FF',color: '#0065FF', borderRadius:'8px'}}>
                                                                                <VisibilityIcon sx={{marginRight:'8px'}} />
                                                                            View
                                                                        </Button>
                                                                    </Grid2>
                                                                </Grid2>
                                                            </Grid2>
                                                        )}
                                                    </>
                                                )}
                                            </Grid2>
                                        </>
                                    )}

                                    {buttonTab==4 && (
                                        <>
                                            <Grid2 sx={{marginTop:'4%'}}>
                                                <Typography sx={{color:'#4E545D', fontWeight:'500', fontSize:'20px'}}>
                                                    {/* Ticket */}
                                                </Typography>
                                            </Grid2>

                                            <Grid2 sx={{marginTop:'2%'}}>
                                                {isCreatingTicket ? (
                                                    <Box sx={{width: '100%', height: '126px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                                        <CircularProgress size={30} color="primary" />
                                                    </Box>
                                                ) : (
                                                    <>
                                                        {(engagementData?.trip_ticket_url !== "" && engagementData?.trip_ticket_url !== null) && (
                                                            // <Button
                                                            //     variant="contained"
                                                            //     color="primary"
                                                            //     onClick={() => setPdfOpen(true)}
                                                            //     sx={{width: '140px',height: '46px',textTransform: 'none', backgroundColor:'#fff', boxShadow:'none',
                                                            //         fontSize: '16px',border: '1px solid #0065FF',color: '#0065FF', borderRadius:'8px'}}>
                                                            //     View
                                                            // </Button>
                                                            <Grid2 container spacing={4} sx={{marginTop:'8px', alignItems:'center'}}>
                                                                <Grid2 item>
                                                                    <img width="120px" height="120px" src={pdfImage} alt="pdf" />
                                                                    <Typography sx={{color:'#83888E', fontSize:'16px'}}>Tripticket.pdf</Typography>
                                                                </Grid2>
                                                                <Grid2 item>
                                                                    <Grid2 item sx={{display:'flex', alignItems:'center'}}>
                                                                        <img height="20px" width="20px" src={greenTick} alt="greenTick" />
                                                                        <Typography sx={{color:'#34C759', fontSize:'16px', marginLeft:'8px'}}>Trip Ticket Created Successfully</Typography>
                                                                    </Grid2>
                                                                    <Grid2 item sx={{marginTop:'6%'}}>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"
                                                                            onClick={() => setPdfOpen(true)}
                                                                            sx={{width: '140px',height: '46px',textTransform: 'none', backgroundColor:'#EDF4FF', boxShadow:'none',
                                                                                fontSize: '16px',border: '1px solid #0065FF',color: '#0065FF', borderRadius:'8px'}}>
                                                                                <VisibilityIcon sx={{marginRight:'8px'}} />
                                                                            View
                                                                        </Button>
                                                                    </Grid2>
                                                                </Grid2>
                                                            </Grid2>
                                                        )}
                                                    </>
                                                )}
                                            </Grid2>
                                        </>
                                    )}

                                    {(buttonTab==5 || buttonTab==6) && (
                                        <>
                                            <Grid2 sx={{marginTop:'6%'}}>
                                                {buttonTab==6 && 
                                                    <Typography sx={{color:'#4E545D', fontWeight:'500', fontSize:'24px'}}>Mark Booking as Foul Trip</Typography>
                                                }
                                                {buttonTab==5 && 
                                                    <Typography sx={{color:'#4E545D', fontWeight:'500', fontSize:'24px'}}>Cancel Booking</Typography>
                                                }
                                            </Grid2>

                                            <Grid2 sx={{marginTop:'3%'}}>
                                                {buttonTab==6 && 
                                                    <Typography sx={{color:'#838484', fontSize:'18px'}}>Please provide a reason for marking this booking as a foul trip</Typography>
                                                }
                                                {buttonTab==5 && 
                                                    <Typography sx={{color:'#838484', fontSize:'18px'}}>Please provide a reason for cancelling this booking</Typography>
                                                }
                                            </Grid2>

                                            <Grid2 sx={{marginTop:'2%'}}>
                                                <TextField
                                                    label="Write here..."
                                                    type="text"
                                                    fullWidth
                                                    value={foulReason}
                                                    onChange={(e) => {
                                                        setFoulReason(e.target.value);
                                                        setIsReasonError(e.target.value.trim() === '');
                                                    }}
                                                    error={isReasonError}
                                                    helperText={isReasonError ? "Please provide a reason" : ""}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            borderRadius: '8px',
                                                        }
                                                    }}
                                                    multiline
                                                    rows={4}
                                                />
                                            </Grid2>

                                            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => handleMarkFoul(buttonTab)}
                                                    sx={{minWidth: '140px',height: '50px',textTransform: 'none', borderRadius:'10px',
                                                        fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                                    {buttonTab==6 ? 'Mark Foul' : 'Cancel Booking'}
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleClose}
                                                    sx={{
                                                        width: '140px',
                                                        height: '50px',
                                                        textTransform: 'none',
                                                        fontSize: '16px', borderRadius:'10px',
                                                        backgroundColor: '#F0F0F0',
                                                        color: '#B0B0B0',
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </>
                                    )}

                            </Paper>

                        </div>
                    </Box>
                </div>
            )}

            <TableContainer className="table-container" sx={{maxHeight:'70vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'booking_id'} direction={orderBy === 'booking_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('booking_id')}>
                                    Booking ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'tms_client_name'} direction={orderBy === 'tms_client_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('tms_client_name')}>
                                    Client
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'driver_name'} direction={orderBy === 'driver_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('driver_name')}>
                                    Driver
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'container_movement_type'} direction={orderBy === 'container_movement_type' ? order : 'asc'}
                                    onClick={() => handleRequestSort('container_movement_type')}>
                                    Type Of Movement
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'container_size'} direction={orderBy === 'container_size' ? order : 'asc'}
                                    onClick={() => handleRequestSort('container_size')}>
                                    Size
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'pickup_address'} direction={orderBy === 'pickup_address' ? order : 'asc'}
                                    onClick={() => handleRequestSort('pickup_address')}>
                                    Source
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'drop_address'} direction={orderBy === 'drop_address' ? order : 'asc'}
                                    onClick={() => handleRequestSort('drop_address')}>
                                    Destination
                                </TableSortLabel>
                            </TableCell>
                            {/* <TableCell>Request Delivery</TableCell> */}
                            {/* <TableCell>Plate No</TableCell> */}
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'pickup_time'} direction={orderBy === 'pickup_time' ? order : 'asc'}
                                    onClick={() => handleRequestSort('pickup_time')}>
                                    Trip Start Date
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header">
                                <TableSortLabel active={orderBy === 'drop_time'} direction={orderBy === 'drop_time' ? order : 'asc'}
                                    onClick={() => handleRequestSort('drop_time')}>
                                    Trip End Date
                                </TableSortLabel>
                            </TableCell>
                            {/* <TableCell>First Container</TableCell> */}
                            <TableCell align="center" className="table-header">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={13} align="center">
                                    <Typography variant="body1">No data found</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        
                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return(
                                <TableRow key={row.booking_id}>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.booking_id}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.tms_client_name}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.driver_name}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.container_movement_type}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.container_size}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pickup_address}</Typography></TableCell>
                                    <TableCell><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.drop_address}</Typography></TableCell>
                                    {/* <TableCell>{row.address}</TableCell> */}
                                    {/* <TableCell>{row.address}</TableCell> */}
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '140px' }}>
                                        {row.pickup_time ? dayjs(row.pickup_time).format('YYYY-MM-DD HH:mm:ss') : ''}
                                    </Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '140px' }}>
                                        {row.drop_time ? dayjs(row.drop_time).format('YYYY-MM-DD HH:mm:ss') : ''}
                                    </Typography></TableCell>
                                    {/* <TableCell>{row.address}</TableCell> */}
                                    <TableCell align="center">
                                        <Button sx={{textTransform: 'none', borderRadius:'8px', width:'140px'}}
                                            variant="contained"
                                            color="primary"
                                            onClick={() => handleViewDetails(row)}
                                        >
                                            View Details
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
            {/* PDF Viewer Modal */}
            <Modal
                open={pdfOpen}
                onClose={() => setPdfOpen(false)}
                aria-labelledby="pdf-viewer-modal"
                aria-describedby="modal-to-view-trip-ticket-pdf"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '80%',
                    height: '80%',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" component="h2">
                            Trip Ticket
                        </Typography>
                        <IconButton onClick={() => setPdfOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    
                    <Box sx={{ flexGrow: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {/* Debug info */}
                        <Typography variant="caption" sx={{ mb: 1, color: 'text.secondary' }}>
                            {engagementData && engagementData?.trip_ticket_url ? 
                                `Loading PDF from: ${engagementData?.trip_ticket_url}` : 
                                'No PDF URL available'}
                        </Typography>
                        
                        {engagementData && engagementData?.trip_ticket_url ? (
                            <Box sx={{ width: '100%', height: '100%', flex: 1 }}>
                                <iframe 
                                    src={engagementData?.trip_ticket_url} 
                                    title="Trip Ticket PDF"
                                    width="100%"
                                    height="100%"
                                    style={{ 
                                        border: 'none',
                                        borderRadius: '4px',
                                        backgroundColor: '#f5f5f5'
                                    }}
                                />
                            </Box>
                        ) : (
                            <Typography>No PDF document available to display</Typography>
                        )}
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={deliveryReceiptPdfOpen}
                onClose={() => setDeliveryReceiptPdfOpen(false)}
                aria-labelledby="pdf-viewer-modal"
                aria-describedby="modal-to-view-trip-ticket-pdf"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '80%',
                    height: '80%',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" component="h2">
                            Trip Ticket
                        </Typography>
                        <IconButton onClick={() => setDeliveryReceiptPdfOpen(false)}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    
                    <Box sx={{ flexGrow: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {/* Debug info */}
                        <Typography variant="caption" sx={{ mb: 1, color: 'text.secondary' }}>
                            {engagementData && engagementData?.deliver_receipt_url ? 
                                `Loading PDF from: ${engagementData?.deliver_receipt_url}` : 
                                'No PDF URL available'}
                        </Typography>
                        
                        {engagementData && engagementData?.deliver_receipt_url ? (
                            <Box sx={{ width: '100%', height: '100%', flex: 1 }}>
                                <iframe 
                                    src={engagementData?.deliver_receipt_url} 
                                    title="Trip Ticket PDF"
                                    width="100%"
                                    height="100%"
                                    style={{ 
                                        border: 'none',
                                        borderRadius: '4px',
                                        backgroundColor: '#f5f5f5'
                                    }}
                                />
                            </Box>
                        ) : (
                            <Typography>No PDF document available to display</Typography>
                        )}
                    </Box>
                </Box>
            </Modal>
        </div>
    )
}

export default Assigned;